import { DecorationModel } from "../_model/DecorationModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import * as d3 from "d3";
import Resize from "../_decorationTools/risezeClass";

export class DecorationRectangle extends DecorationModel {
  constructor() {
    super("DecorationRectangle");

    this.node = null;
    this.moved = false;
    let resize = new Resize();

    this.init = async function (newNode, openDialog) {
      let svg = SingletonFlowchart.svg;
      this.dialog = openDialog;
      this.node = newNode;

      await svg
        .data([newNode])
        .append("g")
        .attr("id", `${newNode.idName}`)
        .on("mouseover", resize.mouseOver)
        .on("mouseout", resize.mouseOut)
        .call(this.setDrag(newNode))

      let g = d3.select(`#${newNode.idName}`);

      g.append("rect")
        .attr("width", newNode.width)
        .attr("height", newNode.height)
        .attr("x", (d) => d.x)
        .attr("y", (d) => d.y)
        .attr("stroke-width", newNode.stroke)
        .style("fill", "#0000")
        .style("stroke", newNode.color)
        .on("click", newNode.readOnly ? this.setOpenDialog(newNode, openDialog) : () => { })
        .on("dblclick", this.setOpenDialog(newNode, openDialog))

      resize.apply(g, newNode)

      return svg;
    };

    this.setOpenDialog = function (d, openDialog) {
      return () => openDialog(d)
    }

    this.setDrag = function () {
      if (this.node.readOnly) return d3.drag();

      let that = this;
      let drag = d3
        .drag()
        .on("start", that.dragstarted)
        .on("drag", (event, d) => that.dragged(event, d, that))
        .on("end", (event, d) => that.dragended(d, that));
      return drag;
    };

    this.dragstarted = function (event, d) {
      SingletonFlowchart.selectNode(`${d.idName}`);

      d3.select(`#${d.idName} > rect`)
        .style("cursor", "grabbing");

      d3.selectAll(`#Rectangle-${d.id} > .circleBox`).remove();
    };

    this.dragged = async function (event, d) {
      SingletonFlowchart.clicked = false;
      d.x = event.x;
      d.y = event.y;

      this.move()
    };

    this.move = async function () {
      let d = this.node;

      await d3
        .select(`.${d.idName}`)
        .raise()
        .attr("x", d.x)
        .attr("y", d.y);

      await d3
        .select(`#${d.idName} > rect`)
        .raise()
        .attr("x", d.x)
        .attr("y", d.y);

      resize.move(d)

    };

    this.dragended = function (node) {
      d3.select(`#${node.idName} > rect`)
        .style("cursor", "grab")

      if (this.moved) {
        SingletonFlowchart.SaveStatus();
        this.moved = false;
      }
    };

    this.setAdjustArea = function () {
      let d = this.node;

      d3.select(`#${d.idName} > rect`)
        .attr("width", d.width)
        .attr("height", d.height)
        .attr("stroke-width", d.stroke)
        .style('stroke', d.color)
    };
  }
}